import AccountNotificationIcon from '@/assets/svg/nav/account_notifications.svg';
import AdminIcon from '@/assets/svg/nav/admins.svg';
import CountryIcon from '@/assets/svg/nav/countries.svg';
import CurrencyIcon from '@/assets/svg/nav/currencies.svg';
import DashboardIcon from '@/assets/svg/nav/dashboard.svg';
import GenerateReportIcon from '@/assets/svg/nav/generate_report.svg';
import HomePageIcon from '@/assets/svg/nav/home_page.svg';
import IssueIcon from '@/assets/svg/nav/issues.svg';
import LocaleIcon from '@/assets/svg/nav/locales.svg';
import MediaIcon from '@/assets/svg/nav/media.svg';
import MessageIcon from '@/assets/svg/nav/messages.svg';
import OtpMsgsIcon from '@/assets/svg/nav/otpMsgs.svg';
import PaymentHistoryIcon from '@/assets/svg/nav/payment-history.svg';
import PaymentIcon from '@/assets/svg/nav/payment-provider.svg';
import PrivacyPolicyIcon from '@/assets/svg/nav/privacy_policy.svg';
import ReportedIssueIcon from '@/assets/svg/nav/reported_issues.svg';
import RoleIcon from '@/assets/svg/nav/roles.svg';
import SentNotificationIcon from '@/assets/svg/nav/send_notification.svg';
import SettingsIcon from '@/assets/svg/nav/settings.svg';
import TenantIcon from '@/assets/svg/nav/tenants.svg';
import TermsCondIcon from '@/assets/svg/nav/terms_cond.svg';
import UserIcon from '@/assets/svg/nav/users.svg';
import ViewReportIcon from '@/assets/svg/nav/view_report.svg';

let adminMenu = [
  // Report
  { heading: 'reports' },
  {
    title: 'dashboard',
    to: '/',
    icon: DashboardIcon,
    is_custom: true,
    perm: 'dashboard.get',
  },
  {
    title: 'generateReports',
    to: 'generate-report',
    icon: GenerateReportIcon,
    is_custom: true,
    perm: 'report_query',
  },
  {
    title: 'viewReports',
    to: 'view-report',
    icon: ViewReportIcon,
    is_custom: true,
    perm: 'report_view',
  },

  // Operations
  { heading: 'operations' },
  {
    title: 'otpMsgs',
    to: 'otp-msgs',
    icon: OtpMsgsIcon,
    is_custom: true,
    perm: 'otpmsg',
  },
  {
    title: 'reportedIssues',
    to: 'issues',
    icon: ReportedIssueIcon,
    is_custom: true,
    perm: 'issue',
  },
  {
    title: 'predefinedIssues',
    to: 'predefined-issues',
    icon: IssueIcon,
    is_custom: true,
    perm: 'predefined_issue',
  },
  {
    title: 'messages',
    to: 'contact-us',
    icon: MessageIcon,
    is_custom: true,
    perm: 'contact_us',
  },

  // payment
  { heading: 'payments' },
  {
    title: 'paymentProvider',
    to: 'payment-providers',
    icon: PaymentIcon,
    is_custom: true,
    perm: 'payment_provider',
  },
  {
    title: 'paymentHistory',
    to: 'payment-history',
    icon: PaymentHistoryIcon,
    is_custom: true,
    perm: 'payment_history',
  },

  // Notification
  { heading: 'notification' },
  {
    title: 'accountNotifications',
    to: 'notifications',
    icon: AccountNotificationIcon,
    is_custom: true,
  },
  {
    title: 'sendNotifications',
    to: 'send-notifications',
    icon: SentNotificationIcon,
    is_custom: true,
    perm: 'send_notification',
  },

  // accounts
  { heading: 'accounts' },
  {
    title: 'admins',
    to: 'admins',
    icon: AdminIcon,
    is_custom: true,
    perm: 'admin',
  },
  {
    title: 'tenants',
    to: 'tenants',
    icon: TenantIcon,
    is_custom: true,
    perm: 'tenant',
  },
  {
    title: 'users',
    to: 'users',
    icon: UserIcon,
    is_custom: true,
    perm: 'user',
  },
  {
    title: 'rolesAndPermissions',
    to: 'roles-and-permissions',
    icon: RoleIcon,
    is_custom: true,
    perm: 'role',
  },

  // page builder
  { heading: 'pageBuilder' },
  {
    title: 'homePage',
    to: 'home-page',
    icon: HomePageIcon,
    is_custom: true,
    perm: 'home_page.get',
  },
  {
    title: 'privacyPolicy',
    to: 'privacy-policy',
    icon: PrivacyPolicyIcon,
    is_custom: true,
    perm: 'settings.privacy_policy',
  },
  {
    title: 'termsAndCondition',
    to: 'terms-cond',
    icon: TermsCondIcon,
    is_custom: true,
    perm: 'settings.terms_cond',
  },
  {
    title: 'mediaLibrary',
    to: 'media',
    icon: MediaIcon,
    is_custom: true,
    perm: 'attachment',
  },

  // settings
  { heading: 'settings' },
  {
    title: 'currencies',
    to: 'currencies',
    icon: CurrencyIcon,
    is_custom: true,
    perm: 'currency',
  },
  {
    title: 'locales',
    to: 'locales',
    icon: LocaleIcon,
    is_custom: true,
    perm: 'locale',
  },
  {
    title: 'countries',
    to: 'countries',
    icon: CountryIcon,
    is_custom: true,
    perm: 'country',
  },
  {
    title: 'settings',
    to: 'settings',
    icon: SettingsIcon,
    is_custom: true,
    perm: 'settings.general_settings',
  },
];

export default adminMenu;
